<div class="px-4 sm:px-8 lg:px-[74px] py-6 sm:py-10">

  <h2 class="text-2xl sm:text-3xl text-gray-900 text-center font-bold mb-6">Image Plagiarism Checker</h2>


  <div class="flex mb-6">
    <div class="w-[800px] max-w-full mx-auto">
      <form #imagePlagiarismCheckerForm="ngForm">
        <div class="upload-box" (click)="fileUploadRef.click()" (drop)="onDrop($event)" (dragover)="allowDrop($event)" (dragenter)="allowDrop($event)">
          <span>
            <img src="../../../../../../../assets/theme/images/icons/photo-plus.svg"  alt="photo-plus"
            class="w-6 h-6 cursor-pointer" />
          </span>
          <p>
            Click to Add or Drag & Drop Images</p>

          <input type="file" id="fileUpload" (change)="onSelect($event)" [accept]="allowedExtensions.join(',')"
            required ngModel #fileInput="ngModel"  class="hidden"
            name="fileUpload" id="fileUpload" #fileUploadRef />
          <!-- <label for="fileUpload">Choose File</label> -->
        </div>
        @if (imagePlagiarismCheckerRequestModel.file) {
        <div class="file-info cursor-pointer" (click)="clear()">
          <span class="file-name">{{ imagePlagiarismCheckerRequestModel.file.name }}</span>
          <span class="clear-button">✖</span>
        </div>
        }
        @if(fileError){
        <div class="text-red-500 text-sm mt-2">{{this.fileError}}</div>
        }
      </form>
    </div>
  </div>

  <div class="mx-auto">



    <div class="flex flex-col lg:flex-row items-center lg:items-start justify-center gap-4 w-full lg:w-[800px] max-w-full mx-auto">

      <div class="w-full min-h-[420px] shrink-0 border border-gray-200 shadow-sm p-4 rounded-2xl bg-white bg-nav-tabs">
        <ul class="flex flex-nowrap items-center text-nowrap cursor-pointer mb-2 list-none p-0 m-0 overflow-x-auto">
          <li class="nav-item">
              <a class="nav-link inline-block px-4 py-2 text-sm"
                  [ngClass]="{'active': activeTab === 'Original'}"
                  (click)="setTab('Original')">
                  See Original
              </a>
          </li>
          <li class="nav-item ms-2">
              <a class="nav-link inline-block px-4 py-2 text-sm"
                  [ngClass]="{'active': activeTab === 'View-Report'}" (click)="setTab('View-Report')">
                  View Report
              </a>
          </li>
          @if (imagePlagiarismCheckerRequestModel.file) {
            <div class="ms-auto mt-2">
              <span>
                <img (click)="clear()" src="../../../../../../../assets/images/reset.svg" title="reset" alt="reset" height="18" width="18"
                  class="w-6 h-6 cursor-pointer" />
              </span>
            </div>
          }
      </ul>


        @if(!imagePlagiarismCheckerRequestModel.file){
        <div class="image-preview">
          <p>No image uploaded yet</p>
        </div>
        }
        @else {
          @if(activeTab === 'Original'){
            <div class="image-preview">
              <img [src]="this.imageUrl" alt="Uploaded" />
            </div>
          }
          @else {
            @if(isLoading){
              <div class="rounded-2xl">
                <div class="h-[400px] w-full bg-gray-400 rounded animate-pulse"></div>
              </div>
              }
            @else if(imagePlagiarismCheckerResponseModel){
              <div #pdfContent id="content-to-pdf" class="max-w-3xl mx-auto p-6 bg-white rounded-2xl shadow-md">
                <div class="mb-1">
                  <p class="text-lg font-semibold text-gray-700 mb-1">AI Generated Percentage
                    <span class="{{getBadgeClass(imagePlagiarismCheckerResponseModel.ai_generated_percentage)}}">{{ imagePlagiarismCheckerResponseModel.ai_generated_percentage }}%</span>
                  </p>
                </div>
                <h3 class="text-lg font-semibold text-gray-700 mb-2">AI Generator Models Contribution</h3>
                <div class="grid-container">
                  <div class="model-box">
                    <span>DALL·E</span>
                    <span class="{{getBadgeClass(imagePlagiarismCheckerResponseModel.ai_generators_models.dalle)}}">{{ imagePlagiarismCheckerResponseModel.ai_generators_models.dalle }}%</span>
                  </div>
                  <div class="model-box">
                    <span>Firefly</span>
                    <span class="{{getBadgeClass(imagePlagiarismCheckerResponseModel.ai_generators_models.firefly)}}">{{ imagePlagiarismCheckerResponseModel.ai_generators_models.firefly }}%</span>
                  </div>
                  <div class="model-box">
                    <span>Flux</span>
                    <span class="{{getBadgeClass(imagePlagiarismCheckerResponseModel.ai_generators_models.flux)}}">{{ imagePlagiarismCheckerResponseModel.ai_generators_models.flux }}%</span>
                  </div>
                  <div class="model-box">
                    <span>GAN</span>
                    <span class="{{getBadgeClass(imagePlagiarismCheckerResponseModel.ai_generators_models.gan)}}">{{ imagePlagiarismCheckerResponseModel.ai_generators_models.gan }}%</span>
                  </div>
                  <div class="model-box">
                    <span>GPT-4o</span>
                    <span class="{{getBadgeClass(imagePlagiarismCheckerResponseModel.ai_generators_models.gpt4o)}}">{{ imagePlagiarismCheckerResponseModel.ai_generators_models.gpt4o }}%</span>
                  </div>
                  <div class="model-box">
                    <span>Ideogram</span>
                    <span class="{{getBadgeClass(imagePlagiarismCheckerResponseModel.ai_generators_models.ideogram)}}">{{ imagePlagiarismCheckerResponseModel.ai_generators_models.ideogram }}%</span>
                  </div>
                  <div class="model-box">
                    <span>Imagen</span>
                    <span class="{{getBadgeClass(imagePlagiarismCheckerResponseModel.ai_generators_models.imagen)}}">{{ imagePlagiarismCheckerResponseModel.ai_generators_models.imagen }}%</span>
                  </div>
                  <div class="model-box">
                    <span>Midjourney</span>
                    <span class="{{getBadgeClass(imagePlagiarismCheckerResponseModel.ai_generators_models.midjourney)}}">{{ imagePlagiarismCheckerResponseModel.ai_generators_models.midjourney }}%</span>
                  </div>
                  <div class="model-box">
                    <span>Recraft</span>
                    <span class="{{getBadgeClass(imagePlagiarismCheckerResponseModel.ai_generators_models.recraft)}}">{{ imagePlagiarismCheckerResponseModel.ai_generators_models.recraft }}%</span>
                  </div>
                  <div class="model-box">
                    <span>Reve</span>
                    <span class="{{getBadgeClass(imagePlagiarismCheckerResponseModel.ai_generators_models.reve)}}">{{ imagePlagiarismCheckerResponseModel.ai_generators_models.reve }}%</span>
                  </div>
                  <div class="model-box">
                    <span>Stable Diffusion</span>
                    <span class="{{getBadgeClass(imagePlagiarismCheckerResponseModel.ai_generators_models.stable_diffusion)}}">{{ imagePlagiarismCheckerResponseModel.ai_generators_models.stable_diffusion }}%</span>
                  </div>
                  <div class="model-box">
                    <span>Deepfake</span>
                    <span class="{{getBadgeClass(imagePlagiarismCheckerResponseModel.ai_generators_models.deepfake)}}">{{ imagePlagiarismCheckerResponseModel.ai_generators_models.deepfake }}%</span>
                  </div>
                  <div class="model-box">
                    <span>Other</span>
                    <span class="{{getBadgeClass(imagePlagiarismCheckerResponseModel.ai_generators_models.other)}}">{{ imagePlagiarismCheckerResponseModel.ai_generators_models.other }}%</span>
                  </div>
                </div>

              </div>

            }

          }
        }


      </div>


    </div>

  </div>


</div>
